import React from 'react';
import {Control, ErrorComponent, Checkbox} from 'MWComponents';
import '../less';
import css from '../../Express/less/form/form.m.less';

export default function template() {
    const model = this.getModel(),
        { customerNameOrCite, contactPhoneNumber, okpo, name, email, agree} = model.fields,
        form = (
            <>
                <div className="title-form">{this.l10n('BUSINESS_NEW_ORDER_MODAL_TITLE')}</div>
                <div className="send-form">
                  <div className="send-form__item">
                    <input
                      type="text"
                      className={`custom-input ${
                        !name.isValid && !name.firstInput ? 'red-color' : ''
                      }`}
                      name="name"
                      value={name.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_3')}
                      maxLength={100}
                      autoComplete="off"
                    />

                    <div className="error-block">
                      <div
                        className={`error-block__msg ${
                          name.errors.length && !name.firstInput
                            ? 'active'
                            : ''
                        }`}
                      >
                        {this.l10n(name.errors.join('.'))}
                      </div>
                    </div>
                  </div>
                  <div className="send-form__item">
                    <input
                      type="text"
                      className={`custom-input ${
                        !email.isValid && !email.firstInput ? 'red-color' : ''
                      }`}
                      name="email"
                      value={email.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_5')}
                      maxLength={70}
                      autoComplete="on"
                    />

                    <div className="error-block">
                      <div
                        className={`error-block__msg ${
                          email.errors.length && !email.firstInput
                            ? 'active'
                            : ''
                        }`}
                      >
                        {this.l10n(email.errors.join('.'))}
                      </div>
                    </div>
                  </div>
                    <div className="send-form__item">
                        <input
                            type="text"
                            className={`custom-input ${
                                !contactPhoneNumber.isValid && !contactPhoneNumber.firstInput
                                    ? 'red-color'
                                    : ''
                            }`}
                            name="contactPhoneNumber"
                            value={contactPhoneNumber.value}
                            onChange={this.handleChange}
                            placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_4')}
                            onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                            maxLength={20}
                            autoComplete="off"
                        />

                        <div className="error-block">
                            <div
                                className={`error-block__msg ${
                                    contactPhoneNumber.errors.length &&
                                    !contactPhoneNumber.firstInput
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                {this.l10n(contactPhoneNumber.errors.join('.'))}
                            </div>
                        </div>
                    </div>
                  <div className="send-form__item">
                    <input
                      type="text"
                      className={`custom-input ${
                        !customerNameOrCite.isValid && !customerNameOrCite.firstInput ? 'red-color' : ''
                      }`}
                      name="customerNameOrCite"
                      value={customerNameOrCite.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n('BUSINESS_NEW_ORDER_MODAL_FIELD_LABEL_1')}
                      onBlur={() => this.onBlurHandle('customerNameOrCite')}
                      maxLength={100}
                      autoComplete="off"
                    />

                    <div className={`error-block ${
                      customerNameOrCite.errors.length && !customerNameOrCite.firstInput
                        ? 'active'
                        : ''
                    }`}>
                      <div
                        className={`error-block__msg`}
                      >
                        {this.l10n(customerNameOrCite.errors.join('.'))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="button-wrapper">
                    <button
                        className="button button-order"
                        onClick={this.sendForm}
                        disabled={!model.isValid}
                    >
                        {this.l10n('SEND_FORM_2')}
                    </button>
                </div>
            </>
        ),
        success = (
            <>
                    <Control className={'success'}>
                        <div className='success-title' dangerouslySetInnerHTML={{__html: this.l10n('BUSINESS_NEW_ORDER_MODAL_SUCCESS_TITLE')}}></div>
                        <div className='success-text' dangerouslySetInnerHTML={{__html: this.l10n('BUSINESS_NEW_ORDER_MODAL_SUCCESS_TEXT')}}></div>
                        <button className='success-btn' onClick={() => this.closeModal()}>{this.l10n('CLOSE_FORM_2')}</button>
                    </Control>
            </>
        ),
        error = (
            <Control className="control" style={{marginTop: '30px'}}>
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        ),
        screens = {
            form,
            success,
            error,
        };

    return (
        <div className="form-wrapper" onClick={this.closeModal}>
            <div className="form-contain">
                <div className="close-btn" onClick={() => this.closeModal()} />
                {screens[this.state.activeScreen]}
            </div>
        </div>
    );
}
